<template>
  <el-dialog
    :title="$attrs.title || $t('confirm_account.title')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-press-escape="true"
    custom-class="elsa-modal"
    :center="false"
    width="255"
    top="100px"
    v-on:closed="closed"
  >
    <slot>
      <img src="@/assets/images/confirm-email.svg" />
      <h2 class="info">
        {{ $attrs.message || $t("confirm_account.check_inbox") }}
      </h2>
      <!--
      <p>
        {{ $t('confirm_account.didnt_receive') }}
        <a @click="resendEmail" href="javascript:void(0)"> {{ $t('confirm_account.resend_confirmation') }} </a>
      </p>
      -->
      <span slot="footer" class="dialog-footer">
        <primary-button @click.native="handleClose">
          {{ $attrs.buttonLabel || $t("confirm_account.got_it") }}
        </primary-button>
      </span>
    </slot>
  </el-dialog>
</template>

<script>
import PrimaryButton from "@/components/common/buttons/PrimaryButton";

export default {
  props: ["dialogVisible"],
  components: {
    PrimaryButton,
  },
  methods: {
    showModal() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("closed", { sendEmail: false });
    },
    closed() {
      this.$emit("closed");
    },
    resendEmail() {
      this.$emit("closed", { sendEmail: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog.elsa-modal .el-dialog__body {
  h2 {
    line-height: 28px;
  }

  p {
    font-weight: 300;
    font-size: 13px;
    margin-top: 16px;
    margin-bottom: 32px;
    align-self: flex-start;
  }

  a {
    cursor: pointer;
  }
}

.el-dialog.elsa-modal .el-dialog__footer {
  button.elsa-primary-button {
    width: 100%;
    margin: 0;
  }
}

.elsa-button {
  width: 202px;
}

::v-deep .el-dialog.elsa-modal .el-dialog__body > h2 {
  padding-bottom: 16px;
}
</style>
